import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS, HIDE_MESSAGE } from '../../constants/action-constants';

const INIT_STATE = {
    loadercount: 0
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_SUCCESS: {
            return {
                ...state,
                loadercount: state.loadercount - 1
            };

        }
        case FETCH_ERROR: {
            return {
                ...state,
                loadercount: state.loadercount - 1
            };
        }
        case FETCH_START: {
            return {
                ...state,
                loadercount: state.loadercount + 1
            };
        }
        case HIDE_MESSAGE: {
            return {
                ...state,
                loadercount: state.loadercount - 1
            };
        }
        default:
            return state;
    }
};
